var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "formWrapper",
      staticClass: "contact-form",
      class: _vm.embedClass,
      attrs: {
        id: "email_signup",
        "data-ajax-submit":
          "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
        action: "//manage.kmail-lists.com/subscriptions/subscribe",
        method: "GET",
        target: "_blank",
        "accept-charset": "UTF-8",
        _lpchecked: "1",
      },
      on: { submit: _vm.showMessaging },
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "form_type", value: "customer" },
      }),
      _c("input", {
        attrs: { type: "hidden", name: "g" },
        domProps: { value: _vm.listId },
      }),
      _c("transition", { attrs: { name: "slideOut" } }, [
        _vm.notSubmitted
          ? _c(
              "div",
              { staticClass: "input input--text", class: _vm.inputClass },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.emailInput,
                      expression: "emailInput",
                    },
                  ],
                  staticClass: "newsletter__input",
                  attrs: {
                    type: "email",
                    name: "email",
                    id: "k_id_email",
                    value: "",
                    "data-error-message": "Email address must be filled out",
                    placeholder: " ",
                    autocorrect: "off",
                    autocapitalize: "off",
                    autocomplete: "email",
                    required: "",
                    "aria-label": "Email",
                  },
                  domProps: { value: _vm.emailInput },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.emailInput = $event.target.value
                    },
                  },
                }),
                _c(
                  "label",
                  {
                    staticClass: "newsletter__input-label",
                    attrs: { for: "k_id_email" },
                  },
                  [_vm._v("Email Address")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "newsletter__button klaviyo_submit_button",
                    class: _vm.buttonClass,
                    attrs: {
                      type: "submit",
                      id: "Subscribe",
                      "aria-label": _vm.buttonText.length
                        ? _vm.buttonText
                        : "Subscribe",
                    },
                  },
                  [
                    _vm.buttonText.length > 0
                      ? _c("span", [_vm._v(_vm._s(_vm.buttonText))])
                      : _vm._e(),
                    _vm.icon
                      ? _c("icon", {
                          staticClass: "icon-submit",
                          attrs: { name: "chevron-right", size: "14px" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c("transition", { attrs: { name: "slideIn" } }, [
        _vm.isSuccess && _vm.message
          ? _c("p", { staticClass: "contact-form__success" }, [
              _vm._v(_vm._s(_vm.message)),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }